import React, { Component } from 'react';
import { Button, Icon, InputNumber, Select, Statistic, Table, message } from 'antd';
import { connect } from 'react-redux';
import { productoDetailURL } from './../../constants';
import * as actions from "./../../store/actions/productos";
import axios from 'axios';
const { Option } = Select;

const columns = [
    {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
    },
    {
        title: 'Nombre',
        dataIndex: 'nombre',
        key: 'nombre',
    },
    {
        title: 'Marca',
        dataIndex: 'marca',
        key: 'marca',
    },
    {
        title: 'Cantidad',
        dataIndex: 'cantidad',
        key: 'cantidad',
    },
    {
        title: 'Costo',
        dataIndex: 'costo',
        key: 'costo',
    },
    {
        title: '',
        dataIndex: 'delete',
        key: 'delete',
    },
];

export class PedidoProductoForm extends Component {
    componentDidMount() {
        this.props.onFetchProductos(this.props.proveedor)
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.productosPedido !== prevProps.productosPedido) { //State is passed as props with redux
            this.calculateTotal() //ir worked on async functions like "handleOnClick" but not when it wasn't async like on the delete handlers
        } //That is why it had to be done here
    }

    handleOnClickPedido = () => {
        axios
            .get(productoDetailURL(this.props.producto))
            .then(res => {
                let productoA = res.data
                productoA["cantidad"] = 1;
                productoA.costo = productoA.costo_del_momento;
                const { productosPedido } = this.props
                let no_existe0 = true
                productosPedido.map(p => {
                    if (productoA.id === p.id || productoA.length === 0) { //check if id is in productosVenta table or if the table is empty
                        message.error('El producto ya esta en el listado');
                        no_existe0 = false
                        return false
                    }
                    return 'I went though all prods and none are repeated'
                });
                if (no_existe0) {
                    let new_state = this.props.productosPedido.concat(productoA)
                    this.props.onChangePedidoProducto(new_state)
                }
            })
            .catch(err => {
                console.log(err);
                message.error('Hubo un error. Recuerda seleccionar un producto.');
                this.setState({ error: err, loading: false });
            });
    };

    handleChange = (nombre, id, e) => { //el nombre es la cantidad o el precio
        let { productosPedido } = this.props;
        let tipo_nombre = (nombre === 'costo' ? 0 : 1) //NaN BUG: dejar en cero el precio mínimo o en uno la cantidad mínima -cuando quitas el cursor del input- deja NaN si no pones un valor y eso causa un error, por eso onblur le pone o 0 al precio o 1 a la cantidad que es el minimo
        let new_state = productosPedido.map(prod => {
            if (prod.id === id) {
                //prod[nombre] = parseFloat(nombre === 'cantidad' ? e : e.target.value)
                prod[nombre] = parseFloat(e === '' || e === null || isNaN(e) ? tipo_nombre : e) //InputNumber de antd, pasa el valor en e, no en e.target.value
            }
            return prod
        })

        this.props.onChangePedidoProducto(new_state)
    };

    onClickDeleteRowHandler = value => {
        let new_state = this.props.productosPedido.filter(prod => prod.id !== value)
        this.props.onChangePedidoProducto(new_state)
    }

    calculateTotal = () => {
        let { productosPedido, onCalcularValorTotal } = this.props;
        let values = productosPedido.map(prod => {
            let tot = parseFloat(prod.cantidad * prod.costo)
            return tot
        })
        function sumVals(total, num) {
            return total + num;
        }
        let valor_tot = (values.length === 0 ? 0 : values.reduce(sumVals))
        onCalcularValorTotal(valor_tot)
    };

    render() {
        const { productos, producto, productosPedido, valorTotal, onHandleSelectProd } = this.props;
        //para dar submit y q los obj PeridoProducto tengan los mismos fields, tendría que usar productoA_V2 pero tendria que hacer un nested map en PedidoProductoForm [{1: {prod, costo, cantidad}}, {2: {prod, costo, cantidad}}]
        let productosB = productosPedido.map(prod => {
            let input_cantidad = <React.Fragment><InputNumber onChange={(e) => this.handleChange('cantidad', prod.id, e)} type="number" style={{ width: '50%' }} defaultValue={prod.cantidad} min={1} /> <span style={{ marginLeft: 10, ...(prod.stock > 2 ? { color: 'green' } : { color: 'red' }), }}> Stock: {prod.stock}</span></React.Fragment>
            let input_costo = <InputNumber onChange={(e) => this.handleChange('costo', prod.id, e)} type="number" style={{ width: '50%' }} placeholder="$" defaultValue={prod.costo} min={0}/>
            let delete_row = (
                <Button onClick={() => this.onClickDeleteRowHandler(prod.id)}>
                    <Icon type="delete" theme="filled" style={{ color: 'red' }} />
                </Button>
            )
            return (
                {
                    key: prod.id,
                    id: prod.id,
                    marca: prod.marca.nombre,
                    nombre: prod.nombre,
                    cantidad: input_cantidad,
                    costo: input_costo,
                    delete: delete_row,
                }
            )
        });

        return (
            <React.Fragment>
                <div style={{ textAlign: 'center' }}>
                    <Table locale={{ emptyText: 'No hay productos seleccionados' }} size={'middle'} columns={columns} dataSource={productosB} bordered={true} pagination={false} />
                    <br></br>
                    <Select
                        showSearch
                        style={{ width: 400 }}
                        placeholder="Buscar producto"
                        optionFilterProp="children"
                        onChange={onHandleSelectProd}
                        value={producto}
                        allowClear={true}
                        autoFocus={true}
                    >
                        {
                            productos.map(p => {
                                return <Option key={p.id} value={p.id}>{p.nombre} {p.id} ({p.stock})</Option>
                            })
                        }
                    </Select>
                    <Button
                        type="primary"
                        style={{ margin: '0.5em' }}
                        onClick={this.handleOnClickPedido}>
                        <Icon type="plus" />
                    </Button>
                    <br></br>
                    <br></br>
                    <Statistic title="Total" prefix={"MX"} value={valorTotal} precision={2} />
                    <br></br>
                    <Button.Group>
                        <Button
                            color="secondary"
                            variant="contained"
                            onClick={this.props.prevStep}>
                            <Icon type="left" /> Regresar
                </Button>

                        <Button
                            color="primary"
                            variant="contained"
                            onClick={this.props.nextStep}>
                            Continuar <Icon type="right" />
                        </Button>
                    </Button.Group>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        productos: state.producto.productos,
        producto: state.producto.producto,
        valorTotal: state.producto.valorTotal,
        proveedor: state.proveedor.proveedor,
        productosPedido: state.producto.productosPedido,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchProductos: (id) => dispatch(actions.loadProductosData(id)),
        onHandleSelectProd: (val) => dispatch(actions.handleSelectChangeProd(val)),
        onChangePedidoProducto: (new_state) => dispatch(actions.changePedidoProducto(new_state)),
        onCalcularValorTotal: (val) => dispatch(actions.calcularValorTotal(val)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PedidoProductoForm);
